import React, { useState, useEffect } from 'react';
import backToTopIcon from '../../assets/images/png/back-to-top-image.png';

const BackToTop = () => {
    const [showScroll, setShowScroll] = useState(false);

    useEffect(() => {
        const checkScrollTop = () => {
            if (!showScroll && window.pageYOffset > 400) {
                setShowScroll(true);
            } else if (showScroll && window.pageYOffset <= 400) {
                setShowScroll(false);
            }
        };

        window.addEventListener('scroll', checkScrollTop);

        return () => {
            window.removeEventListener('scroll', checkScrollTop);
        };
    }, [showScroll]);

    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div
            className={`rounded-5 backtotop_animation cursor_pointer transition_03 ${showScroll ? 'd-block' : 'd-none'}`}
            id="back_to_top"
            onClick={scrollTop}
        >
            <div className="d-flex justify-content-center align-items-center h-100">
                <img
                    className="back_to_top_icon"
                    src={backToTopIcon}
                    alt="icon"
                />
            </div>
        </div>
    );
};

export default BackToTop;
